import { render, staticRenderFns } from "./DataSummary.vue?vue&type=template&id=72eda77f&scoped=true&"
import script from "./DataSummary.vue?vue&type=script&lang=js&"
export * from "./DataSummary.vue?vue&type=script&lang=js&"
import style0 from "./DataSummary.vue?vue&type=style&index=0&id=72eda77f&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72eda77f",
  null
  
)

export default component.exports
import QBtn from 'quasar/src/components/btn/QBtn.js';
import QScrollArea from 'quasar/src/components/scroll-area/QScrollArea.js';
import QDialog from 'quasar/src/components/dialog/QDialog.js';
import qInstall from "../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(component, 'components', {QBtn,QScrollArea,QDialog});
